/**
 * Функция включена, когда её объект конфигурации присутствует, если только не `enable: false`.
 *
 * Используется функциями, сигналом включения которых является «конфигурация присутствует» (Группа 1).
 * Функции, сигналом включения которых является что-то иное (Hover → взаимодействие, TotalRow → колонки
 * totalConverter), НЕ должны использовать этот помощник — отсутствующая конфигурация не выключает их.
 */
export function isFeatureEnabled(cfg: { enable?: boolean } | null | undefined): boolean {
  return !!cfg && cfg.enable !== false;
}
